<div class="app-inner-layout">
    <section class="container header-section-website">
        <div class="row">
            <div class="col-8 flex-row d-flex justify-content-start align-items-center">
                <a href="https://www.mobilitateurbana4.ro" class="back-link"><i class="fa-solid fa-angles-left"></i>
                    Înapoi în site</a>
            </div>
            <div class="col-4 flex-row d-flex justify-content-end align-items-center">
                <a href="https://www.mobilitateurbana4.ro">
                    <img src="../../../assets/img/logo-ps4-dmu.png" class="img-fluid" />
                </a>
            </div>
        </div>
    </section>
    <section class="container-fluid header-bg">
        <div class="bg-overlay"></div>
        <div class="row">
            <div class="container">
                <div class="col-sm-12">
                    <h4 style="text-transform: uppercase">MOBILITATE URBANĂ</h4>
                    <br />
                    <h1>Ridicări Auto</h1>
                </div>
            </div>
        </div>
    </section>
    <div class="container">
        <div class="row">
            <div class="col-12 mt-2 mb-2">
                <h1 class="text-center border-bottom custom-border-color">Plată Tarif ridicare, transport si depozitare autovehicul</h1>
            </div>
        </div>
        <!-- <div class="row mb-5 pb-5 mt-5">
            <div class="col-12 divider-line-heading">
                <div>
                    <span class="outer-line"></span>
                    <i class="fa-solid fa-file-lines"></i>
                    <span class="outer-line"></span>
                </div>
                <h3 class="manropeFamily">Regulament
                </h3>
            </div>
        </div> -->
        <!-- <div class="row">
            <div class="col-12">
                <ul class="custom-list">
                    <li class="list-item">
                        <a href="https://dev.regenerareurbana4.ro/wp-content/uploads/2023/05/REGULAMENT-RIDICARI_-in-vigoare.pdf"
                            target="_blank">

                            <span class="list-item-icon"><i class="fa-solid fa-cloud-arrow-down"></i></span>
                            <span class="list-item-text">REGULAMENT privind procedura de ridicare a
                                autovehiculelor, prevăzută de Regulamentul de aplicare a Ordonanţei de urgenţă a
                                Guvernului nr. 195/2002, aprobat prin Hotărârea Guvernului nr. 1.391/2006, cu
                                modificările şi completările ulterioare, precum și ridicarea vehiculelor prevăzută de
                                Ordonanţa nr. 21/2002 privind gospodărirea localităţilor urbane şi rurale cu
                                modificările şi completările ulterioare, pe străzile și domeniul public aflat în
                                administrarea Sectorului 4 al Municipiului București</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div> -->
    </div>
    <!-- <div class="container">
        <div class="row mb-5 pb-5 mt-5">
            <div class="col-12 divider-line-heading">
                <div>
                    <span class="outer-line"></span>
                    <i class="fa-solid fa-magnifying-glass-location"></i>
                    <span class="outer-line"></span>
                </div>
                <h3 class="manropeFamily">Informații privind Autoturisme ridicate de pe Raza Sectorului 4
                </h3>
            </div>
        </div>
    </div> -->
    <section class="container-fluid header-bg">
        <!-- <div class="bg-overlay"></div> -->
        <!-- <div class="row"> -->
        <div class="container">
            <div class="row d-flex flex-row justify-content-between align-items-center">
                <div class="col-sm-12 col-md-6">
                    <p class="manropeFamily whiteText pb-1 pt-1">Plata cu cardul online poate fi
                        efectuată utilizând numărul autovehiculului dumneavoastră, sau utilizând seria și numărul
                        dispoziției de ridicare.</p>
                    <p class="manropeFamily whiteText pb-1 pt-1">Pe baza Referinței introduse
                        puteți achita următoarele:</p>
                    <ul class="whiteText">
                        <li>
                            <p class="manropeFamily whiteText mb-0">Tarif Ridicare Autovehicul : 244 RON (TVA inclus)</p>
                        </li>
                        <li>
                            <p class="manropeFamily whiteText mb-0">Tarif Transport Autovehicul: 244 RON (TVA inclus)</p>
                        </li>
                        <li>
                            <p class="manropeFamily whiteText mb-0">Tarif Depozitare Autovehicul: 162 RON (TVA inclus) - primele
                                24h</p>
                        </li>
                        <li>
                            <p class="manropeFamily whiteText mb-0">Tarif Depozitare Autovehicul: 82 RON (TVA inclus)/24h
                                (peste primele 24h)</p>
                        </li>

                    </ul>

                    <p class="manropeFamily whiteText pb-1 pt-1">Pentru siguranță, tranzacțiile
                        sunt procesate de către EuPlătesc.ro în numele Direcției pentru MOBILITATE URBANĂ Urbană Sector 4, utilizând
                        soluţii anifraudă avansată care duc la diminuare riscurilor asociate tentativelor de fraudă
                        electronică.</p>
                </div>
                <div class="col-sm-12 col-md-6" *ngIf="showSuccess">
                    <h4 class="manropeFamily whiteText">Aveți de plată următoarele:</h4>
                    <br />
                    <p class="manropeFamily whiteText">Număr Auto: <strong>{{formData.value.numar_auto}}</strong></p>
                    <p class="manropeFamily whiteText">Descriere: <strong>{{formResult.tax_name}}</strong></p>
                    <p class="manropeFamily whiteText">Total: <strong>{{formResult.total}} (TVA Inclus)</strong></p>
                    
                    <br />
                    <br />
                    <br />
                    <button type="button" (click)="processPaymentLink()"
                        class="btn-block btn-lg btn btn-outline-warning whiteText">
                        Plătește acum
                    </button>
                    <br />
                    <br />
                    <br />
                    <button type="button" (click)="resetForm()"
                        class="btn-block btn-lg btn btn-outline-warning whiteText">
                        Resetare Verificare
                    </button>
                </div>
                <div class="col-sm-12 col-md-6 whiteText" *ngIf="!showSuccess">
                    <form [formGroup]="formData" (ngSubmit)="checkAuto()">

                        <!-- nume -->
                        <div class="col-sm-12">
                            <div
                                class="form-group d-flex flex-column justify-content-center align-items-start white-text">
                                <label for="numar_auto" class="manropeFamily">Număr Auto <span
                                        class="red-text">*</span></label>
                                <mat-form-field class="custom-input w-100" appearance="outline">
                                    <input formControlName="numar_auto" placeholder="B123ABC.." matInput
                                        [errorStateMatcher]="matcher" type="text" required="required">
                                    <mat-error class="p-2"
                                        *ngIf="(numar_auto.dirty || numar_auto.touched) && numar_auto.errors?.required">
                                        <strong>Câmp obligatoriu</strong>
                                    </mat-error>
                                    <mat-error class="p-2"
                                        *ngIf="(numar_auto.dirty || numar_auto.touched) && numar_auto.errors?.minlength">
                                        <strong>Minim 3 caractere</strong>
                                    </mat-error>

                                    <mat-error class="p-2"
                                        *ngIf="(numar_auto.dirty || numar_auto.touched) && numar_auto.errors?.maxlength">
                                        <strong>Max 12 caractere</strong>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-sm-12 mt-3">
                            <div class="form-group">
                                <mat-checkbox formControlName="termeni_conditii" class="mt-5 mb-5 termeni_conditii">
                                    Sunt de acord cu
                                    <a href="https://www.mobilitateurbana4.ro/politica-de-confidentialitate/" target="_blank">termenii și
                                        condițiile de confidențialitate ale Direcției Mobilitate Urbană Sector 4</a>
                                </mat-checkbox>
                            </div>
                        </div>
                        <div class="col-12 mt-5">
                            <div class="form-group">
                                <button type="submit" [disabled]="!formData.valid"
                                    class="btn-block btn-lg btn btn-outline-light">
                                    Verificare Auto
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <!-- </div> -->
    </section>
    <section class="container">
        <div class="row">
            <div class="col-12 mt-5 mb-5 d-flex flex-row justify-content-between align-items-center custom-images-flex-logos">
                <div><img src="../../../../assets/img/euplatesc.jpg" class="img-fluid" /></div>
                <div><img src="../../../../assets/img/Mastercard-new-logo.jpg" style="max-width:45%" class="img-fluid" /></div>
                <div><img src="../../../../assets/img/visa.jpg" style="max-width:60%" class="img-fluid" /></div>
                <div><img src="../../../../assets/img/bt-2048x425.jpg" style="max-width:80%" class="img-fluid" /></div>
            </div>
        </div>
    </section>
</div>